import { Dropdown } from './../../models/dropdown.model';
import { OPTIONAL } from './../../constants/constant';
import { Component, OnInit, Input, EventEmitter, Output } from '@angular/core';
import { FormControl, AbstractControl } from '@angular/forms';
import { Category } from '../../models/category.model';

@Component({
  selector: 'app-dropdown',
  templateUrl: './dropdown.component.html',
  styleUrls: ['./dropdown.component.scss','../input-textbox/input-textbox.component.scss']
})
export class DropdownComponent implements OnInit {

  @Input() labelName: string;
  @Input() inputFormControl: FormControl;
  @Input() options: Dropdown[];
  @Input() submitted = false;
  @Input() readOnlyMode = false;
  @Input() placeHolder = 'Please select Value';
  @Input() showCommentIcon = false;
  @Input() commentObject: FormControl;
  @Input() tooltiptxt: string;
  @Input() showOptionalLabel = true;
  @Input() labelTextTransformNone = false;
  @Input() reqDropdownParentID = false;
  @Output() onShowComment = new EventEmitter();

  selectedVal: any;

  OPTIONAL = OPTIONAL;

  constructor() { }

  ngOnInit(): void {
  }

  public onChange(): void{

  }

  get isRequiredField(): boolean {
    if (!this.inputFormControl.validator) {
      return false;
    }

    const validator = this.inputFormControl.validator({} as AbstractControl);
    return (validator && validator.required);
  }

  getDropdownValue(): string {
    if (this.inputFormControl.value === "-1") {
        this.inputFormControl.setValue(null);
    }
    if (this.inputFormControl && this.inputFormControl.value) {
      if (this.reqDropdownParentID) {
        const index = this.options.findIndex((x: Dropdown) => x.masterID === new Number(this.inputFormControl.value));
        return this.options[index].masterName;
      }
      const index = this.options.findIndex((x: Dropdown) => x.dropdownID === this.inputFormControl.value);
      return this.options[index].dropdownDesc;
    }
    return '';
  }

  getClasses(): string {
    if (this.inputFormControl &&
    (this.submitted || this.inputFormControl.touched) &&
      this.inputFormControl.errors){
        if (this.showCommentIcon) {
          return 'error-input show-comment-input';
        }
        return 'error-input';
      } else {
        if (this.showCommentIcon) {
          return 'show-comment-input';
        }
        return '';
      }
    }

}
